import api from "@/api/axios";
import { ApiResponse } from "@/types/apiResponse";
import { DestinyMatrix, MatrixDescription } from "@/types/destinyMatrix";

export async function fetchDestinyMatrix(
  day: number,
  month: number,
  year: number
) {
  const res = await api.get<ApiResponse<DestinyMatrix>>("/destiny-matrix", {
    params: {
      day: day,
      month: month,
      year: year,
    },
  });

  return res.data.data;
}

export async function getMatrixDescription(matrixKey: string, date: string) {
  const res = await api.get<ApiResponse<string | MatrixDescription>>(
    "/destiny-matrix/description",
    {
      params: {
        matrix_key: matrixKey,
        matrix_date: date,
      },
    }
  );

  return res.data.data;
}

export async function downloadPdfResults(
  date: string,
  userName: string | null
) {
  const response = await api.get("/destiny-matrix/download", {
    params: {
      matrix_date: date,
      user_name: userName,
    },
    responseType: "blob",
  });

  return response.data;
}
